import { latestChapters } from "@/mocks/manga";

const thumbs: Record<number, string> = {
  1: "https://bainwo.github.io/api/search-image?query=anime%20manga%20panel%20illustration%20of%20a%20cozy%20youth%20romance%20scene%20with%20warm%20peach%20tones%2C%20a%20gyaru%20girl%20making%20breakfast%20in%20a%20bright%20apartment%20kitchen%2C%20soft%20morning%20light%2C%20romantic%20manga%20art%20style%2C%20gentle%20atmosphere%2C%20high%20detail&width=600&height=800&seq=thumb-1&orientation=portrait",
  2: "https://bainwo.github.io/api/search-image?query=anime%20manga%20panel%20illustration%20of%20a%20boy%20and%20a%20gyaru%20girl%20sharing%20two%20mugs%20on%20a%20couch%20at%20night%2C%20warm%20peach%20and%20cream%20room%2C%20soft%20lamplight%2C%20youth%20romance%20manga%20art%20style%2C%20cozy%20mood%2C%20high%20detail&width=600&height=800&seq=thumb-2&orientation=portrait",
  3: "https://bainwo.github.io/api/search-image?query=anime%20manga%20panel%20illustration%20of%20two%20people%20sharing%20one%20umbrella%20in%20the%20rain%20near%20a%20warm%20convenience%20store%2C%20peach%20and%20soft%20blue%20dusk%20tones%2C%20youth%20romance%20manga%20art%20style%2C%20tender%20mood%2C%20high%20detail&width=600&height=800&seq=thumb-3&orientation=portrait",
  4: "https://bainwo.github.io/api/search-image?query=anime%20manga%20panel%20illustration%20of%20a%20gyaru%20girl%20and%20a%20boy%20eating%20snacks%20watching%20tv%20on%20the%20floor%20at%20night%2C%20warm%20cozy%20room%2C%20peach%20lighting%2C%20youth%20romance%20manga%20art%20style%2C%20playful%20mood%2C%20high%20detail&width=600&height=800&seq=thumb-4&orientation=portrait",
  5: "https://bainwo.github.io/api/search-image?query=anime%20manga%20panel%20illustration%20of%20a%20boy%20finding%20a%20diary%20on%20a%20desk%20while%20a%20gyaru%20girl%20runs%20toward%20him%2C%20warm%20apartment%20interior%2C%20peach%20tones%2C%20youth%20romance%20manga%20art%20style%2C%20surprised%20mood%2C%20high%20detail&width=600&height=800&seq=thumb-5&orientation=portrait",
  6: "https://bainwo.github.io/api/search-image?query=anime%20manga%20panel%20illustration%20of%20two%20people%20making%20hotpot%20together%20at%20a%20table%20on%20christmas%20eve%2C%20warm%20festive%20lighting%2C%20peach%20and%20gold%20tones%2C%20youth%20romance%20manga%20art%20style%2C%20heartwarming%20mood%2C%20high%20detail&width=600&height=800&seq=thumb-6&orientation=portrait",
};

export default function Chapters() {
  return (
    <section id="chapters" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-flashlight-fill text-sm" />
              最近更新
            </span>
            <h2 className="font-heading mt-3 text-3xl text-foreground-950 md:text-4xl">
              最新话更新进度
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              最新内容已置顶，追更泡在我家的辣妹不用到处找，刷新即可看到最新话。
            </p>
          </div>
          <a
            href="#catalog"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
          >
            查看全部章节
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {latestChapters.map((ch, i) => (
            <article
              key={ch.id}
              className="group flex gap-4 rounded-lg bg-background-50 p-4 ring-1 ring-background-200/70 transition-shadow hover:ring-primary-200"
            >
              <div className="relative h-[120px] w-[92px] shrink-0 overflow-hidden rounded-md">
                <img
                  src={thumbs[ch.id]}
                  alt={`泡在我家的辣妹 第${ch.num}话《${ch.title}》缩略图`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                {i === 0 && (
                  <span className="absolute left-1.5 top-1.5 rounded bg-primary-500 px-1.5 py-0.5 text-[10px] text-background-50">
                    最新
                  </span>
                )}
              </div>
              <div className="flex min-w-0 flex-col">
                <div className="flex items-center gap-2">
                  <span className="text-xs text-foreground-600">{ch.volume}</span>
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800">
                    {ch.pages}P
                  </span>
                </div>
                <h3 className="font-heading mt-2 text-lg leading-snug text-foreground-950">
                  第{ch.num}话 · {ch.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  更新于 {ch.date}
                </p>
                <a
                  href="#catalog"
                  className="mt-auto inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
                >
                  <i className="ri-arrow-right-s-line" />
                  直达阅读
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}